import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { _ } from '../../shared/utils';
import { LandingPageTile } from '~app/shared/tiles/home-tile.model';
import { SidebarPanelComponent } from '~app/sidebar/sidebar-panel/sidebar-panel.component';
import { AppMessageService } from '~app/shared/app-message/app-message.service';
import { SidebarService } from '~app/shared/sidebar/sidebar.service';
import { AuthService } from '~app/auth/auth.service';
import { InfluxGraphComponent } from '~app/influx/influx-graph/influx-graph.component';
import { Subject } from 'rxjs';
import { TenantConfig } from '~app/shared/map/layer/layer-definitions/tenant-config.type';

@Component({
  selector: 'qm-measurements-table',
  templateUrl: './measurements-table.component.html',
  styleUrls: ['./measurements-table.component.scss']
})
export class MeasurementsTableComponent extends SidebarPanelComponent {
  private static onShow$ = new Subject<void>();

  @ViewChild('influxGraph')
  private readonly influxGraph?: InfluxGraphComponent;

  public tenant: number;
  public tenantConfig: TenantConfig;
  protected componentName = MeasurementsTableComponent.getComponentName();

  constructor(protected sidebarService: SidebarService,
              protected appMessageService: AppMessageService,
              private authService: AuthService
              ) {
    super(appMessageService, sidebarService);
    this.tenant = this.authService.getTenant();
    this.tenantConfig = this.authService.getTenantConfig();
    MeasurementsTableComponent.onShow$.subscribe(() => {
      if (this.influxGraph) {
        this.influxGraph.loadCurrentFeature();
      }
    });
  }

    /**
   * Configure the `LandingPageTile` for this component
   * @override
   */
  public static initTile(tile: LandingPageTile) {
    tile.description = _('Measurements table');
    tile.icon = 'far fa-tachometer';
    tile.title = _('Measurements table');
    tile.panel = MeasurementsTableComponent.getComponentName();
    tile.onShow = this.onShow$.next.bind(this.onShow$);
  }

  /**
   * @returns {string} Name of the component, used for panel and authorization APIs
   */
  public static getComponentName(): string {
    return 'measurements-table';
  }

}
